function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { decl } from '@yandex-lego/i-bem-react';
export default decl({
  block: 'checkbox',
  elem: 'control',
  tag: 'input',
  attrs: function attrs(_ref) {
    var id = _ref.id,
        name = _ref.name,
        value = _ref.value,
        checked = _ref.checked,
        disabled = _ref.disabled,
        labeledBy = _ref.labeledBy,
        onChange = _ref.onChange,
        _attrs = _ref.attrs,
        tabIndex = _ref.tabIndex,
        indeterminate = _ref.indeterminate;
    return _objectSpread({
      id: id,
      name: name,
      disabled: disabled,
      value: value,
      tabIndex: tabIndex,
      type: 'checkbox',
      autoComplete: 'off',
      checked: Boolean(checked),
      // Keep input controlled: http://bit.ly/2eY7an2
      'aria-labelledby': labeledBy,
      'aria-checked': indeterminate ? 'mixed' : checked,
      onChange: disabled ? undefined : onChange
    }, _attrs);
  }
});